export default "__VITE_ASSET__lAlBOPal__"